import { ElMessage } from 'element-plus'
import type { RouteLocationRaw, Router } from 'vue-router'

import { useUserStore } from '@/stores/user'

const LOGIN_PATH = '/login'
const LOGIN_ROUTE_NAME = 'Login'

let redirectingToLogin = false

function normalizeRedirectTarget(target?: string | null) {
  const normalized = String(target || '').trim()
  if (!normalized || !normalized.startsWith('/') || normalized.startsWith('//')) {
    return ''
  }
  if (normalized === LOGIN_PATH || normalized.startsWith(`${LOGIN_PATH}?`)) {
    return ''
  }
  return normalized
}

export function clearPersistedSession() {
  try {
    useUserStore().logout()
    return
  } catch {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('rememberedUsername')
  }
}

export function buildLoginLocation(target?: string | null): RouteLocationRaw {
  const redirect = normalizeRedirectTarget(target)
  return redirect
    ? { name: LOGIN_ROUTE_NAME, query: { redirect } }
    : { name: LOGIN_ROUTE_NAME }
}

export function resolvePostLoginRedirect(target: unknown, fallback: string) {
  return normalizeRedirectTarget(typeof target === 'string' ? target : '') || fallback
}

export function redirectToLogin(router: Router, target?: string | null) {
  clearPersistedSession()

  if (redirectingToLogin || router.currentRoute.value.path === LOGIN_PATH) {
    return Promise.resolve()
  }

  redirectingToLogin = true
  return router.replace(buildLoginLocation(target || router.currentRoute.value.fullPath)).finally(() => {
    redirectingToLogin = false
  })
}

export function notifyRegistrationUnavailable() {
  ElMessage.info('注册暂未开放，后续会重新开启。')
}
